import { render, staticRenderFns } from "./card_face.vue?vue&type=template&id=36dce598&scoped=true"
import script from "./card_face.vue?vue&type=script&lang=js"
export * from "./card_face.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36dce598",
  null
  
)

export default component.exports